"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportPeriodSection = void 0;
/**
 * ============================
 * REPORT PERIOD DOCUMENT
 * ============================
 */
var ReportPeriodSection;
(function (ReportPeriodSection) {
    ReportPeriodSection["PAYMENTS"] = "reports_period_payments";
    ReportPeriodSection["SALES"] = "reports_period_sales";
    ReportPeriodSection["CUSTOMERS"] = "reports_period_customers";
    ReportPeriodSection["CUSTOMERS_ACTIVITY"] = "reports_period_customers_activity";
    ReportPeriodSection["CUSTOMERS_REVENUE"] = "reports_period_customers_revenue";
    ReportPeriodSection["TAX"] = "reports_period_tax";
    ReportPeriodSection["SHIPPING"] = "reports_period_shipping";
})(ReportPeriodSection = exports.ReportPeriodSection || (exports.ReportPeriodSection = {}));
